// @core/api/endpoints/localization/list_glossary_entries.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListGlossaryEntriesResponse,
} from '../../../types/localization';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/localization';

/**
 * List glossary entries
 * Returns all glossary entries. Supports search by term.
 */
export async function ListGlossaryEntries(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListGlossaryEntriesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/glossary`;
  const requestOptions = options;
  return client.get<ListGlossaryEntriesResponse>(requestPath, { ...requestOptions, params });
}
